import React from "react";
import { ToggleButton, ToggleWrapper } from "./elements";

const AccountInsightsIntervalToggle = ({ value, onChange, translate }) => (
	<ToggleWrapper>
		<ToggleButton
			type="button"
			$active={value === "day"}
			onClick={() => onChange("day")}>
			{translate("accountInsights.interval.day")}
		</ToggleButton>
		<ToggleButton
			type="button"
			$active={value === "week"}
			onClick={() => onChange("week")}>
			{translate("accountInsights.interval.week")}
		</ToggleButton>
	</ToggleWrapper>
);

export default AccountInsightsIntervalToggle;
